<template>
  <div>
    <!-- <a-button type="primary" @click="addResult">同步最近对话并分析</a-button> -->
    <a-descriptions bordered>
      <template slot="title">
        <span style="margin-right: 4px">AI总结({{ usemodel }})</span>
        <a-popover title="说明" placement="topLeft">
          <template v-if="usemodel.includes('qw')" slot="content">
            <p>AI技术来自于阿里通义千问</p>
            <p>计费标准：按照token收费，目前官网查询价格大致如下<a href="https://help.aliyun.com/zh/model-studio/billing-for-model-studio?spm=5176.29004136.commonbuy2container.1.4a02778bcZrtNA">官网地址</a></p>
            <p>统计区间：按照现有用户会话分析处理结果，如果有新的会话，请更新后再重新触发ai分析</p>
          </template>
          <template v-else-if="usemodel== 'deep-seek-r1'" slot="content">
            <p>AI技术来自于工程效能部自建模型</p>
            <p>完全免费！</a></p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>

      <template v-if="aiInfo && (aiInfo.usage != null || aiInfo.length > 0)">
        <a-descriptions-item label="是否解决">
          <a-tag v-if="solved === '否'" color="red">
            {{ solved }}
          </a-tag>
          <a-tag v-if="solved === '是'" color="green">
            {{ solved }}
          </a-tag>
        </a-descriptions-item>
        <a-descriptions-item label="消耗token总数"> {{ usedTotalToken }} </a-descriptions-item>
        <a-descriptions-item label="对话轮次"> {{ connectionTimes }} </a-descriptions-item>
        <a-descriptions-item label="用户满意轮次">{{ userSatisfiedTimes }} </a-descriptions-item>
        <a-descriptions-item label="停止原因"> {{ stopReason }}</a-descriptions-item>
        <a-descriptions-item label="归属域">
          <p v-for="domain in domainList">
            {{ domain.domain }}
          </p>
        </a-descriptions-item>
        <a-descriptions-item label="问题类型归纳"> {{ questionSummary }}</a-descriptions-item>
        <a-descriptions-item label="归属域原因" :span="2"> {{ domainReason }}</a-descriptions-item>
        <a-descriptions-item label="问题概述" :span="3">
          {{ problem }}
        </a-descriptions-item>
        <a-descriptions-item label="客服解释" :span="3">
          {{ explanation }}
        </a-descriptions-item>
        <a-descriptions-item label="用户认为未解决的原因" :span="3">
          {{ disSolvedReason }}
        </a-descriptions-item>
        <a-descriptions-item label="解决方案" :span="3">
          {{ solution }}
        </a-descriptions-item>
        <a-descriptions-item label="回复得分" :span="2">
          {{ point }}
        </a-descriptions-item>
        <a-descriptions-item label="扣分原因">
          {{ pointReason }}
        </a-descriptions-item>
        <a-descriptions-item label="质检得分" :span="2">
          {{ qualityPoint }}
        </a-descriptions-item>
        <a-descriptions-item label="质检扣分原因">
          {{ qualityPointReason }}
        </a-descriptions-item>
      </template>
      <template v-if="!aiInfo || (aiInfo.usage == null && aiInfo.length == 0)">
        <a-descriptions-item label="ai结论">
          {{ '暂无ai相关推荐内容' }}
        </a-descriptions-item>
      </template>
    </a-descriptions>
    <div slot="footer" />
  </div>
</template>

<script>
import { problemUrgencys, problemStatus, ticketStatus, problemChannels, ticketDomain, ticketLevel, ticektTag, qiyuTicketStatus } from '@/utils/dictionary';
import { taskStatus } from '@/utils/dictionary';
import { queryIssuesByIds } from '@/api/project/issue';
import { syncNewConn } from '@/api/event/problem';
export default {
  components: {},
  props: {
    aiInfo: {}
  },

  data() {
    return {
      bugList: [],
      reqList: [],
      isNewResult: false,
      solved: '否',
      usedTotalToken: 0,
      connectionTimes: 0,
      point: 0,
      pointReason: '',
      qualityPoint: 0,
      qualityPointReason: '',
      userSatisfiedTimes: 0,
      usemodel: 'qwen',
      stopReason: '',
      questionType: '',
      domainList: [],
      domainReason: '',
      questionSummary: '',
      explanation: '',
      disSolvedReason: '',
      solution: '',
      problem: '',
      loading: false,
      relationItems: [],
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id',
          width: 50,
          scopedSlots: { customRender: 'customKey' }
        },
        {
          title: '标题',
          width: 100,
          dataIndex: 'title',
          key: 'title',
          scopedSlots: { customRender: 'title' }
        },
        {
          title: '类型',
          width: 50,
          dataIndex: 'type',
          key: 'type'
        },
        {
          title: '创建时间',
          width: 50,
          dataIndex: 'createdTime',
          key: 'createdTime'
        }
      ]
    };
  },
  mounted() {
    this.parseObj();
  },

  methods: {
    addResult() {
      syncNewConn({ ticket_id: this.ticket_id, from: this.from, qiyu_ticket_id: this.qiyu_ticket_id }).then(res => {
        console.log(res);
      });
    },
    parseObj() {
      try {
        if (!this.aiInfo) {
          console.log('aiInfo is null or undefined');
          return;
        }
        if (this.aiInfo.usage != null) {
          (this.solved = this.aiInfo.content[0].solved), (this.usedTotalToken = this.aiInfo.usage.totalTokens + this.aiInfo.domain_usage.totalTokens), (this.connectionTimes = this.aiInfo.content[0].interaction_sessions), (this.userSatisfiedTimes = this.aiInfo.content[0].satisfactory_replies), (this.stopReason = this.aiInfo.finishReason), (this.usemodel = 'qwen-plus-latest');
          (this.questionType = this.aiInfo.ai_domain[0].question_type), (this.domainList = this.aiInfo.ai_domain[0].evaluate), (this.domainReason = this.aiInfo.ai_domain[0].evaluate[0].reason), (this.questionSummary = this.aiInfo.ai_domain[0].question_type), (this.problem = this.aiInfo.content[0].problem), (this.explanation = this.aiInfo.content[0].explanation), (this.disSolvedReason = this.aiInfo.content[0].user_disapproval_reason), (this.solution = this.aiInfo.content[0].solution);
        } else if (this.aiInfo.usage == null && this.aiInfo.length != 0 && this.aiInfo[0] != null) {
          // 兼容内部deep-seek-r1的代码逻辑
          let summaryObj = this.safeJSONParse(this.aiInfo[0].AiResult);
          if (!summaryObj) return;

          if (summaryObj.code != null) {
            // 检查 summaryObj.data 是否为字符串
            if (typeof summaryObj.data === 'string') {
              summaryObj = this.safeJSONParse(summaryObj.data);
            } else if (typeof summaryObj.data === 'object' && summaryObj.data !== null) {
              // 如果已经是对象，直接使用
              summaryObj = summaryObj.data;
            } else {
              console.warn('summaryObj.data is not a valid JSON string or object:', summaryObj.data);
              return;
            }
            if (!summaryObj) return;
          }
          console.log(summaryObj);
          if (summaryObj.usage != null) {
            this.usedTotalToken = summaryObj.usage.total_tokens;
          }
          if (this.aiInfo.length > 1) {
            const domainObj = this.safeJSONParse(this.aiInfo[1].AiResult);
            if (domainObj && domainObj.choices && domainObj.choices[0] && domainObj.choices[0].message) {
              const domainContent = this.safeJSONParse(domainObj.choices[0].message.content);
              if (domainContent && domainContent[0]) {
                this.questionSummary = domainContent[0].question_type;
                this.domainList = domainContent[0].evaluate;
                this.domainReason = domainContent[0].evaluate && domainContent[0].evaluate[0] ? domainContent[0].evaluate[0].reason : '';
                if (domainObj.usage) {
                  this.usedTotalToken = this.usedTotalToken + domainObj.usage.total_tokens;
                }
              }
            }
            
            if (this.aiInfo.length > 2) {
              const moveObj = this.safeJSONParse(this.aiInfo[2].AiResult);
              if (moveObj && moveObj.usage) {
                this.usedTotalToken = this.usedTotalToken + moveObj.usage.total_tokens;
              }
            }
          }
          let summaryContent = summaryObj;
          if (summaryObj.choices != null && summaryObj.choices[0] && summaryObj.choices[0].message) {
            summaryContent = this.safeJSONParse(summaryObj.choices[0].message.content);
          }
          if (summaryContent && summaryContent[0]) {
            this.connectionTimes = summaryContent[0].interaction_sessions;
            (this.usemodel = this.aiInfo[0].Channel),
            (this.solved = summaryContent[0].solved),
            (this.userSatisfiedTimes = summaryContent[0].satisfactory_replies),
            (this.problem = summaryContent[0].problem),
            (this.solution = summaryContent[0].solution),
            (this.explanation = summaryContent[0].explanation),
            (this.disSolvedReason = summaryContent[0].user_disapproval_reason),
            (this.point = summaryContent[0].point),
            (this.pointReason = summaryContent[0].deduction_reason),
            (this.qualityPoint = summaryContent[0].quality_point),
            (this.qualityPointReason = summaryContent[0].quality_deduction_reason);
          }
        }
      } catch (error) {
        console.error('Error parsing AI info:', error);
        console.log('AI Info data:', this.aiInfo);
      }
    },
    
    // 安全的JSON解析方法
    safeJSONParse(jsonString) {
      try {
        if (typeof jsonString === 'string') {
          return JSON.parse(jsonString);
        } else if (typeof jsonString === 'object' && jsonString !== null) {
          // 如果已经是对象，直接返回
          return jsonString;
        } else {
          console.warn('Invalid JSON input:', jsonString);
          return null;
        }
      } catch (error) {
        console.error('JSON parse error:', error);
        console.log('Failed to parse:', jsonString);
        return null;
      }
    }
  }
};
</script>

<style scoped>
.purple {
  background-color: rgba(128, 50, 150, 0.5);
  color: white;
  border-radius: 6px;
}

.orange {
  background-color: orange;
  color: white;
  border-radius: 6px;
}

.purple-orange {
  background: linear-gradient(to right, rgba(128, 50, 150, 0.5) 50%, orange 50%);
  color: white;
  border-radius: 6px;
}
</style>
